import { generatePath } from "react-router";
import { deserialize, serialize } from "serializr";
import { NotificationTypes } from "../../../enums/notificationTypes";
import axiosInstance from "../../../interceptor/axiosInstance";
import {
  PreviousPaperModel,
  PreviousPaperQuestionsModel,
} from "../../../models/ExamModels/PreviousPaperModel/previouspaper.model";
import { PaginationModel } from "../../../models/PaginationModel/pagination.model";
import * as apiRoutes from "../../../routes/routeConstants/apiRoutes";
import Notification from "../../../shared/components/Notification";
import { convertJSONToFormData } from "../../../shared/utils/converJsonToFormData";
export class PreviousPaperService {
  static fetchPreviousPaper(
    queryParams: any,
    onSuccess: Function,
    onError: Function
  ) {
    return axiosInstance
      .get(apiRoutes.PREVIOUS_PAPER_LIST + queryParams)
      .then((response) => {
        const data = deserialize(
          PreviousPaperModel,
          response["data"]["papers"]
        );
        const meta = deserialize(PaginationModel, response["data"]["meta"]);
        onSuccess(data, meta);
      })
      .catch((error) => {
        onError(error);
      });
  }
  static createPreviousPaper(
    data: PreviousPaperModel,
    onSuccess: Function,
    onError: Function
  ) {
    const serializeData = serialize(PreviousPaperModel, data);
    const payload = { paper: serializeData };
    return axiosInstance
      .post(apiRoutes.PREVIOUS_PAPER_LIST, payload)
      .then((response) => {
        const data = deserialize(PreviousPaperModel, response["data"]["paper"]);
        onSuccess(data);
      })
      .catch((error) => {
        onError(error);
      });
  }

  static fetchQuestionsbyPaper(
    paperId: any,
    onSuccess: Function,
    onError: Function
  ) {
    return axiosInstance
      .get(apiRoutes.PREVIOUS_PAPER_QUESTIONS, {
        params: {
          paper_id: paperId,
        },
      })
      .then((response) => {
        const data = deserialize(
          PreviousPaperQuestionsModel,
          response["data"]["paper_questions"]
        );
        onSuccess(data);
      })
      .catch((error) => {
        onError(error);
      });
  }
  static deletePreviousPaper(
    paperId: any,
    onSuccess: Function,
    onError: Function
  ) {
    return axiosInstance
      .delete(generatePath(apiRoutes.PREVIOUS_PAPER_ID, { id: paperId }))
      .then((response) => {
        onSuccess(response);
      })
      .catch((error) => {
        onError(error);
      });
  }
  static updatePreviousPaper(
    paperId: any,
    data: PreviousPaperModel,
    onSuccess: Function,
    onError: Function
  ) {
    const serializeData = serialize(PreviousPaperModel, data);
    const payload = { paper: serializeData };
    return axiosInstance
      .put(generatePath(apiRoutes.PREVIOUS_PAPER_ID, { id: paperId }), payload)
      .then((response) => {
        onSuccess(response);
      })
      .catch((error) => {
        onError(error);
      });
  }
  static createPaperQuestion(
    data: any,
    onSuccess: (question: PreviousPaperQuestionsModel) => void,
    onError: Function
  ) {
    return axiosInstance
      .post(apiRoutes.PREVIOUS_PAPER_QUESTIONS, data)
      .then((response: any) => {
        const question = deserialize(
          PreviousPaperQuestionsModel,
          response["data"]?.paper_question
        );
        onSuccess(question);
      })
      .catch((error) => {
        onError(error);
      });
  }
  static updatePaperQuestion(
    id: number,
    data: any,
    onSuccess: (question: PreviousPaperQuestionsModel) => void,
    onError: Function
  ) {
    return axiosInstance
      .put(generatePath(apiRoutes.PREVIOUS_PAPER_QUESTION_ID, { id: id }), data)
      .then((response: any) => {
        const question = deserialize(
          PreviousPaperQuestionsModel,
          response["data"]?.paper_question
        );
        onSuccess(question);
      })
      .catch((error) => {
        onError(error);
      });
  }
  static deletePaperQuestion(id: any, onSuccess: Function, onError: Function) {
    return axiosInstance
      .delete(generatePath(apiRoutes.PREVIOUS_PAPER_QUESTION_ID, { id: id }))
      .then((response) => {
        onSuccess(response);
      })
      .catch((error) => {
        onError(error);
      });
  }
  static uploadBulkPaperQuestions(
    payload: any,
    onSuccess: () => void,
    onError: (errors: any, row: any) => void,
    onFinal: () => void,
  ) {
    return axiosInstance
      .post(apiRoutes.BULK_PAPER_QUESTIONS, payload, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        onSuccess();
      })
      .catch((error) => {
        const { response } = error;
        onError(response?.data[0]?.error, response?.data[0]?.row);
        Notification({
          message: "Uploading failed",
          description: "Something went wrong",
          type: NotificationTypes.ERROR,
        });
      }).finally(onFinal)
    }
}
